/* eslint-disable */
import { Checkbox } from '../../Components/ui/checkbox'
import env from '../../env/env'
import { toCurrency } from '../../utils/CurrencyUtil'
import { capitalizeWords } from '../../utils/Util'

const ActionPlanPlanCards = ({
  adminPlans,
  selectedPlans,
  openPlans,
  handleCheckboxChange,
  togglePlan,
  onOpen,
  isDesktop,
}) => {
  return (
    <div className='gap-2 pb-56 md:flex md:pb-0'>
      <div className='flex flex-[2] flex-col gap-4 md:grid md:grid-cols-2 md:gap-4 lg:grid-cols-2'>
        {adminPlans?.map((plan, index) => {
          return (
            <div
              key={plan.customerBasketInvestmentId + index}
              className='fabits-card overflow-hidden p-4 transition-all duration-300 ease-in-out hover:border-primary-200 md:p-5'
            >
              <div className='flex justify-between'>
                <div className='flex items-start gap-3'>
                  <Checkbox
                    className='mt-1 h-5 w-5'
                    checked={selectedPlans?.some((p) => p.basketIndex === plan?.basketIndex)}
                    onCheckedChange={() => handleCheckboxChange(plan)}
                  />
                  <div className='font-IBM text-base font-bold leading-snug text-black-950 md:text-lg'>
                    {plan.customerBasketName}
                  </div>
                </div>
              </div>

              <div className='mt-4 grid grid-cols-1 gap-3 min-[380px]:grid-cols-2'>
                <div className='rounded-lg border border-black-100 bg-black-50 p-3'>
                  <h1 className='fabits-eyebrow flex items-center gap-2'>One time</h1>
                  <p className='mt-2 font-IBM text-lg font-bold text-black-950 md:text-xl'>
                    ₹
                    {plan.oneTimeInvestmentAmount && plan?.oneTimeStatus === 'PENDING'
                      ? toCurrency(plan.oneTimeInvestmentAmount)
                      : 0}
                  </p>
                  {plan.oneTimeInvestmentAmount > 0 && plan?.oneTimeStatus === 'PENDING' && (
                    <p
                      className='mt-3 cursor-pointer font-DMSans text-xs font-semibold text-primary-600 hover:text-primary-700'
                      onClick={() => {
                        onOpen('oneTimeBreakdown', {
                          constituents: plan?.oneTimeInvestmentBreakdown?.filter(
                            (fund) => fund?.weightage != 0,
                          ),
                        })
                      }}
                    >
                      View Funds
                    </p>
                  )}
                </div>

                {(plan?.sipStatus === 'PENDING' || plan?.sipStatus === 'ACTIVE') && (
                  <div className='rounded-lg border border-black-100 bg-black-50 p-3'>
                    <h1 className='fabits-eyebrow flex flex-wrap items-center gap-2'>
                      SIP{' '}
                      <span
                        className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold normal-case tracking-normal ${
                          capitalizeWords(plan?.sipStatus) === 'Active'
                            ? 'border-secondary-300 bg-secondary-300 text-black-950'
                            : 'border-warning-500 bg-warning-50 text-warning-700'
                        }`}
                      >
                        {capitalizeWords(plan?.sipStatus) === 'Active' ? 'Active' : 'Pending'}
                      </span>
                    </h1>

                    <p className='mt-2 font-IBM text-lg font-bold text-black-950 md:text-xl'>
                      ₹{plan.sipInvestmentAmount ? toCurrency(plan.sipInvestmentAmount) : 0}
                    </p>

                    {plan.sipInvestmentAmount > 0 && (
                      <p
                        className='mt-3 cursor-pointer font-DMSans text-xs font-semibold text-primary-600 hover:text-primary-700'
                        onClick={() => {
                          onOpen('sipBreakdown', {
                            constituents: plan?.sipInvestmentBreakdown?.filter(
                              (fund) => fund?.weightage != 0,
                            ),
                            totalAmount: plan?.sipInvestmentAmount,
                          })
                        }}
                      >
                        View Funds
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div onClick={() => togglePlan(plan.customerBasketInvestmentId)}>
                {openPlans[plan.customerBasketInvestmentId] && (
                  <>
                    {((plan.sipInvestmentAmount > 0 && !plan.oneTimeInvestmentAmount) ||
                      (plan.oneTimeInvestmentAmount > 0 && plan.sipInvestmentAmount > 0)) && (
                      <div className='my-3 border-t border-black-200 md:mt-5'>
                        {plan?.sipInvestmentBreakdown?.length > 0 &&
                          plan?.sipInvestmentBreakdown?.map((breakup, breakupIndex) => {
                            const percentage =
                              (breakup.investmentAmount / plan.sipInvestmentAmount) * 100
                            return (
                              <div
                                key={breakupIndex}
                                className='mt-3 flex items-center justify-between gap-6'
                              >
                                <div className='flex min-w-0 items-center gap-2'>
                                  <img
                                    src={`${env.MF_LOGOS_URL}/${breakup.amcCode}.png`}
                                    alt={`${breakup.name} icon`}
                                    className='h-6 w-6 shrink-0 rounded-lg border border-black-100 md:h-8 md:w-8'
                                  />
                                  <p className='truncate font-DMSans text-sm font-medium text-black-700'>
                                    {isDesktop
                                      ? breakup?.schemeName
                                      : `${breakup?.schemeName.slice(0, 20)}...`}
                                  </p>
                                </div>
                                <p className='font-JetBrains text-xs font-semibold text-black-500'>
                                  {percentage}%
                                </p>
                              </div>
                            )
                          })}
                      </div>
                    )}

                    {plan.oneTimeInvestmentAmount > 0 && plan.sipInvestmentAmount === 0 && (
                      <div className='my-3 border-t border-black-200 md:mt-5'>
                        {plan?.oneTimeInvestmentBreakdown.length > 0 &&
                          plan?.oneTimeInvestmentBreakdown?.map((breakup, breakupIndex) => {
                            const percentage =
                              (breakup.investmentAmount / plan.oneTimeInvestmentAmount) * 100
                            return (
                              <div
                                key={breakupIndex}
                                className='mt-3 flex items-center justify-between gap-6'
                              >
                                <div className='flex min-w-0 items-center gap-2'>
                                  <img
                                    src={`${env.MF_LOGOS_URL}/${breakup.amcCode}.png`}
                                    alt={`${breakup.name} icon`}
                                    className='h-6 w-6 shrink-0 rounded-lg border border-black-100 md:h-8 md:w-8'
                                  />
                                  <p className='truncate font-DMSans text-sm font-medium text-black-700'>
                                    {isDesktop
                                      ? breakup?.schemeName
                                      : `${breakup?.schemeName.slice(0, 20)}...`}
                                  </p>
                                </div>
                                <p className='font-JetBrains text-xs font-semibold text-black-500'>
                                  {percentage}%
                                </p>
                              </div>
                            )
                          })}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ActionPlanPlanCards
